import { FC, useCallback, useEffect, useState } from 'react'

import { ActiveProductsContext } from '.'
import { IActiveProduct, IActiveProductsContext } from './types'

export const STORAGE_KEY = '@doris:active_products'

export const ActiveProductsProvider: FC = ({ children }) => {
  const initialProducts = () => {
    const storedProducts = localStorage.getItem(STORAGE_KEY)
    return storedProducts ? JSON.parse(storedProducts) : []
  }

  const [products, setProducts] = useState<Array<IActiveProduct>>(initialProducts)

  const syncToLocalStorage = useCallback((payload: IActiveProduct[]) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  }, [])

  const addActiveProduct: IActiveProductsContext['addActiveProduct'] = ({
    identifier,
    has_viton,
    has_size,
    thumbnail,
    type,
  }) => {
    const candidate = { identifier, has_viton, has_size, thumbnail, type }

    setProducts(prevProducts => {
      return [
        ...prevProducts.filter(p => p.identifier !== candidate.identifier && p.type !== candidate.type),
        candidate,
      ]
    })
  }

  const removeActiveProduct: IActiveProductsContext['removeActiveProduct'] = useCallback(
    ({ identifier }) => {
      const newValue = products.filter(p => p.identifier !== identifier)

      setProducts(newValue)
    },
    [products],
  )

  const clearActiveProducts = useCallback(() => {
    setProducts([])
  }, [])

  useEffect(() => {
    syncToLocalStorage(products)
  }, [products, syncToLocalStorage])

  const value = {
    products,
    addActiveProduct,
    removeActiveProduct,
    clearActiveProducts,
  }

  return <ActiveProductsContext.Provider value={value}>{children}</ActiveProductsContext.Provider>
}
